var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelCoupon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1365",
    "data-name": "Grupo 1365",
    transform: "translate(-374.172 -336.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1284",
    "data-name": "Grupo 1284",
    transform: "translate(374.172 336.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_528",
    "data-name": "Rect\\xE1ngulo 528",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#d70a30",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_66",
    "data-name": "L\\xEDnea 66",
    x2: 12.16,
    transform: "translate(380.462 348.848)",
    fill: "none",
    stroke: "#d70a30",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCoupon);
export default __webpack_public_path__ + "static/media/cancel_coupon.8e974989e59f3740c801fa70d58a8bc0.svg";
export { ForwardRef as ReactComponent };